import React from 'react'
import QtdModulo from '../../ModulosCrefito/QtdModulo'
import AiTipo from './AiTipo'

const AiContainer = () => {
    return (
        <>
            <QtdModulo texto="AUTOS DE INFRAÇÃO" modulo="aito" />
            <AiTipo modulo="aito" />
        </>
    )
}

export default AiContainer